/**
 * diagnostics — lekkie ring-buffery dla auto-kontekstu zgłoszeń (2026-05-19).
 *
 * Łapie ostatnie:
 *   - błędy JS (window.onerror, unhandledrejection, console.error) — ze stackiem
 *   - nieudane zapytania API (4xx/5xx) — metoda + url + status
 *
 * Czytane przez ReportIssueButton przy wysyłce zgłoszenia.
 * Bufory in-memory (nie localStorage) — znikają po reloadzie, brak PII na dysku.
 */

const MAX_ERRORS = 10;
const MAX_REQUESTS = 10;

const _errors = [];
const _requests = [];

function _push(arr, item, max) {
  arr.push(item);
  if (arr.length > max) arr.shift();
}

function _trim(s, n = 500) {
  if (s == null) return '';
  const str = String(s);
  return str.length > n ? str.slice(0, n) + '…' : str;
}

export function recordJsError(kind, message, stack) {
  _push(_errors, {
    kind,
    message: _trim(message, 400),
    stack: _trim(stack, 1200),
    at: new Date().toISOString(),
  }, MAX_ERRORS);
}

export function recordFailedRequest(method, url, status, detail) {
  _push(_requests, {
    method: String(method || '').toUpperCase(),
    url: _trim(url, 300),
    status,
    detail: _trim(detail, 300),
    at: new Date().toISOString(),
  }, MAX_REQUESTS);
}

export function getDiagnostics() {
  return {
    js_errors: _errors.slice(-MAX_ERRORS),
    failed_requests: _requests.slice(-MAX_REQUESTS),
  };
}

let _installed = false;

export function initDiagnostics() {
  if (_installed || typeof window === 'undefined') return;
  _installed = true;

  window.addEventListener('error', (e) => {
    try {
      recordJsError(
        'window.onerror',
        e?.message || 'Unknown error',
        e?.error?.stack || `${e?.filename || ''}:${e?.lineno || ''}:${e?.colno || ''}`,
      );
    } catch { /* never break the app */ }
  });

  window.addEventListener('unhandledrejection', (e) => {
    try {
      const r = e?.reason;
      recordJsError(
        'unhandledrejection',
        (r && (r.message || r.toString())) || 'Unhandled promise rejection',
        (r && r.stack) || '',
      );
    } catch { /* */ }
  });

  // Patch console.error (zachowaj oryginał)
  const orig = window.console && window.console.error;
  if (typeof orig === 'function') {
    window.console.error = (...args) => {
      try {
        const msg = args
          .map((a) => {
            if (a instanceof Error) return a.message;
            if (typeof a === 'object') { try { return JSON.stringify(a); } catch { return String(a); } }
            return String(a);
          })
          .join(' ');
        const stack = args.find((a) => a instanceof Error)?.stack || '';
        recordJsError('console.error', msg, stack);
      } catch { /* */ }
      return orig.apply(window.console, args);
    };
  }
}
